import { showErrorToast } from "../../../configurator/renderer/tools/helper";
import { useEasyServicePostApiEasyRedirectToEasy } from "../../../openapi/api/queries/queries";
import { ErrorType } from "../../CustomCartIdRouteComponent/CustomCartIdRouteComponent";
import { cartStore } from "../../CustomCartIdRouteComponent/storeCart";

import { useEffect, useState } from "react";
import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { VMLineItems } from "@4pace-cpq/core";
import { Button, CircularProgress } from "@mui/material";
import { useStore } from "@tanstack/react-store";

type EasyServicePostApiEasyRedirectToEasyResponse = {
  returnUrl: string;
};

type EasyError = {
  applicationProductId: string;
  exceptionMessage: string;
};

type JmpToEasyError = {
  status: number;
  body: {
    returnUrl: "";
    returnLocation: "";
    cpqErrorList: {
      [key: string]: string;
    };
    easyErrorList: EasyError[];
  };
};

export const BtnJumpToEasy = ({
  lineItems,
  setErrorList,
  disabled,
}: {
  disabled: boolean;
  lineItems?: VMLineItems[] | null;
  setErrorList: (error: ErrorType[]) => void;
}): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [easyURL, setEasyURL] = useState<string>("");
  const { t } = useTranslation();
  const selectedItems = useStore(
    cartStore,
    (state): string[] => state["selectedItems"],
  );

  const { mutate: redirectToEasy } = useEasyServicePostApiEasyRedirectToEasy();

  const handleClick = async (): Promise<boolean> => {
    setIsLoading(true);

    const updateSelectedItems = lineItems
      ?.filter((item) => selectedItems?.includes(item.id))
      .map((item) => item.id);

    redirectToEasy(
      { requestBody: { lineItems: [...(updateSelectedItems ?? [])] } },
      {
        onSuccess: (data: unknown) => {
          const responseData =
            data as EasyServicePostApiEasyRedirectToEasyResponse;
          if (responseData?.returnUrl) {
            setEasyURL(responseData.returnUrl);
            console.log({ responseData });
            window.location.href = responseData.returnUrl;
          }
        },
        onError: (error) => {
          const errorData = error as JmpToEasyError;
          console.log(errorData);
          if (errorData.status === 409) {
            setErrorList(errorData.body.easyErrorList);
            if (errorData.body.cpqErrorList) {
              Object.entries(errorData.body.cpqErrorList).map((value, key) => {
                showErrorToast(
                  t(`WEG:${key}`, errorData.body.cpqErrorList[value[key]]),
                );
              });
            }
          }
          if (errorData.status === 504) {
            showErrorToast(t("WEG:toast.JmpToEasy.timeout"));
          }
        },
      },
    );

    setIsLoading(false);

    return true;
  };

  useEffect(() => {
    if (easyURL) {
      //document.getElementById("jump-to-easy-link")?.click();
    }
  }, [easyURL]);

  return (
    <>
      {/* <a
        id="jump-to-easy-link"
        href={easyURL}
        target="_self"
        style={{ visibility: "hidden" }}
      >
        debugLink
      </a> */}
      <Button
        variant="contained"
        size="small"
        onClick={handleClick}
        disabled={disabled}
      >
        {isLoading ? (
          <CircularProgress size={"1em"} sx={{ mr: ".25em" }} />
        ) : null}
        {t("WEG:btn.loginToEasy")}
      </Button>
    </>
  );
};
